import motors from '@/store/modules/motor/motors';
import types from '@/store/modules/motor/types';
import axios from 'axios';

export default {
  namespaced: true,
  modules: {
    motors,
    types,
  },

  state: {
    preferences: {
      unit: 'newton',
      pressure: 0,
      lpm: 0,
      cc: 0,
      efficiency: 80,
      selectedMotor: 1,
      selectedMotorType: null,
      rpm: null,
      torque: null,
      power: null,
    },
    build: {},
  },
  getters: {
    getMotorPreferences(state) {
      return state.preferences;
    },
    getAllMotorTypes(state, getters, rootState, rootGetters) {
      return rootGetters['motorConfigTypes/getAll'];
    },
    getAllMotors(state, getters, rootState, rootGetters) {
      return rootGetters['motorConfigMotors/getAll'];
    },
    getBuildObject(state) {
      return {
        motorconfig_id: state.preferences.selectedMotor,
        unit: state.preferences.unit,
      };
    },
  },
  actions: {
    setUnit: ({ commit }, unit) => {
      commit('setUnit', unit);
    },
    selectMotor: ({ commit }, val) => {
      commit('selectMotor', val);
    },
    getBuildId({getters}) {
      const buildObject = getters['getBuildObject'];
      return axios.post(process.env.VUE_APP_API_URL + 'motorConfig/builds/make', {build: buildObject})
        .then((response) => {
          return response.data.uid;
        });
    },
    fetchBuild({ dispatch }, uid) {
      return axios.get(process.env.VUE_APP_API_URL + 'motorConfig/builds/' + uid)
        .then(({ data }) => {
          return data;
        });
    },
    loadBuild({dispatch, rootGetters, commit}, build) {
      if (build !== undefined) {
        const motor = rootGetters['build/motorConfig/motors/getAll'].find(x => x.id === build.motorconfig_id);
        if (motor) {
          dispatch('selectMotor', motor.id);
        }
      }
    },
  },
  mutations: {
    setUnit(state, unit) {
      state.preferences.unit = unit;
    },
    setPressure(state, pressure) {
      state.preferences.pressure = pressure;
    },
    setLpm(state, lpm) {
      state.preferences.lpm = lpm;
    },
    setCc(state, cc) {
      state.preferences.cc = cc;
    },
    setEfficiency(state, percentage) {
      state.preferences.efficiency = percentage;
    },
    selectMotorType(state, value) {
      state.preferences.selectedMotorType = value;
    },
    selectMotor(state, motor) {
      state.preferences.selectedMotor = motor;
    },
  },
};